"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _withSize = _interopRequireDefault(require("./withSize"));

var _excluded = ["loading"];

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var animation = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  0% { transform: rotateZ(45deg); }\n  100% { transform: rotateZ(1125deg); }\n"])));

var SpinAnimation = _styledComponents["default"].g(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  transform-origin: 12px;\n  animation: ", " 1.125s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite;\n"])), animation);

var LoadingIndicator = function LoadingIndicator(_ref) {
  var color = _ref.color,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    version: "1.1",
    className: className,
    "data-testid": "loading-indicator-icon"
  }, /*#__PURE__*/_react["default"].createElement(SpinAnimation, null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,19.5 C7.85786438,19.5 4.5,16.1421356 4.5,12 C4.5,7.85786438 7.85786438,4.5 12,4.5 C16.1421356,4.5 19.5,7.85786438 19.5,12 C19.5,16.1421356 16.1421356,19.5 12,19.5 Z M12,18.5 C15.5898509,18.5 18.5,15.5898509 18.5,12 C18.5,8.41014913 15.5898509,5.5 12,5.5 C8.41014913,5.5 5.5,8.41014913 5.5,12 C5.5,15.5898509 8.41014913,18.5 12,18.5 Z",
    fill: color,
    opacity: "0.7"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 L4,12 C4,7.581722 7.581722,4 12,4 Z",
    fill: color
  })));
};

LoadingIndicator.propTypes = {
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  width: _propTypes["default"].number.isRequired,
  height: _propTypes["default"].number.isRequired
};
LoadingIndicator.defaultProps = {
  color: 'inherit',
  className: ''
};
var SizedLoadingIndicator = (0, _withSize["default"])(LoadingIndicator);

var withLoadingIndicator = function withLoadingIndicator(Icon) {
  var AnimatedIcon = function AnimatedIcon(_ref2) {
    var loading = _ref2.loading,
        props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);

    if (loading) {
      return /*#__PURE__*/_react["default"].createElement(SizedLoadingIndicator, props);
    }

    return /*#__PURE__*/_react["default"].createElement(Icon, props);
  };

  AnimatedIcon.propTypes = {
    loading: _propTypes["default"].bool
  };
  AnimatedIcon.defaultProps = {
    loading: false
  };
  return AnimatedIcon;
};

var _default = withLoadingIndicator;
exports["default"] = _default;